import React, { useEffect, useRef, useState } from 'react'
import { NodeViewWrapper } from '@tiptap/react'
import { observer } from 'mobx-react-lite'
import { MediaPlayer } from '@trivie/ui-web/components/media-player/media-player'
import { ResourceApi } from '@trivie/core/src/services/api-objects'
import { CircularProgress } from '@mui/material'
import { DateTime } from 'luxon'
import { useStores } from '@trivie/core'

export const VideoNode = observer((props: any) => {
  const { utilityStore } = useStores()
  const { sourceRefresh, setSourceRefresh } = utilityStore
  const [source, setSource] = useState('')

  const load = async () => {
    if (!source) {
      const res = await ResourceApi.getSourceDetails(props.node.attrs.source_id)
      setSource(res.data.filename_or_url)
      // setSourceRefresh(props.node.attrs.source_id, Date.now())
      return res
    }
  }

  useEffect(() => {
    load()
    // const lastRefresh = sourceRefresh?.get(props.node.attrs.source_id)
    // if (source && lastRefresh) {
    //   const expired = DateTime.fromMillis(lastRefresh).diffNow('minutes').minutes < -15
    //   if (expired) {
    //     reload()
    //   }
    // } else {
    //   load()
    // }
  }, [props.node.attrs.source_id])

  const playerRef = useRef() as any

  return (
    <NodeViewWrapper>
      {source ? (
        <MediaPlayer
          playerContainerStyleOverride={{ borderRadius: 12 }}
          // thumbnail="https://images.unsplash.com/photo-1484589065579-248aad0d8b13?q=80&w=3648&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
          url={source}
          ref={playerRef}
          variant="video"
          onError={() => {}}
        />
      ) : (
        <CircularProgress style={{ margin: '0 auto', display: 'flex', alignSelf: 'center' }} />
      )}
    </NodeViewWrapper>
  )
})
